import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { aboutBrand } from '@/mocks/about';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const quickNav = [
    { path: '/', label: t('nav_home') },
    { path: '/category/ri', label: t('nav_anime') },
    { path: '/category/m-boy', label: t('nav_manga') },
    { path: '/article/autumn-2026-preview', label: t('nav_article') },
    { path: '/about', label: t('nav_about') },
  ];

  const resources = [
    { path: '/category/ri', label: '日漫' },
    { path: '/category/guo', label: '国漫' },
    { path: '/category/new', label: '新番' },
    { path: '/category/m-boy', label: '少年漫' },
    { path: '/category/m-youth', label: '青年漫' },
  ];

  return (
    <footer className="bg-accent-700 text-background-50" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/20 text-lg">
                <i className="ri-tv-2-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl">动漫网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-50/80">{t('footer_slogan')}</p>
            <p className="mt-3 text-xs leading-relaxed text-background-50/60">{t('footer_tips')}</p>
          </div>

          {/* Quick nav */}
          <nav aria-label={t('footer_quick')}>
            <h4 className="text-sm font-semibold text-background-50">{t('footer_quick')}</h4>
            <ul className="mt-4 space-y-2">
              {quickNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-50/75 transition hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Resources */}
          <nav aria-label={t('footer_resources')}>
            <h4 className="text-sm font-semibold text-background-50">{t('footer_resources')}</h4>
            <ul className="mt-4 space-y-2">
              {resources.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-50/75 transition hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50">{t('footer_contact')}</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-50/75">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5" aria-hidden="true"></i>
                <span className="break-all">{aboutBrand.contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5" aria-hidden="true"></i>
                <span>{aboutBrand.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5" aria-hidden="true"></i>
                <span>{aboutBrand.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/20 pt-6 sm:flex-row">
          <p className="text-xs text-background-50/70">{t('footer_copyright', { year })}</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#" className="text-xs text-background-50/70 transition hover:text-background-50">
              {t('footer_beian')}
            </a>
            <a href="#" rel="nofollow" className="text-xs text-background-50/70 transition hover:text-background-50">
              {t('footer_links')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}